// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"Bg-z"};